import React from "react";
import "../../assets/css/seller-review.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Seller_sidebar from "./Seller-sidebar/Seller_sidebar";
import Seller_tabs_list from "./Seller-sidebar/Seller_tabs_list";
import { detail_order_img, product_inventory, star } from "../../constants";
import { useEffect } from "react";
import $ from "jquery";
import SellerHeader from "../../components/SellerHeader/SellerHeader";
import SellerFooter from "../../components/SellerFooter/SellerFooter";

const Seller_Reviews = () => {
	useEffect(() => {
		$(document).ready(function () {
			$("#staticBackdrop button.close").click(function () {
				$("#staticBackdrop").modal("toggle");
			});
		});
	}, []);
	return (
		<>
			{/* Header starts here */}
			<SellerHeader />
			{/* Header ends here */}
			<section className="dashboard">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<Seller_sidebar />
						</div>
						<div className="col-lg-8 refunr-ore pus">
							<Seller_tabs_list />

							<div className="cutomer-res" style={{ marginTop: "30px" }}>
								<div className="content-wrapper">
									<h3>Customer Reviews</h3>
								</div>
								<div className="table-responsive">
									<table className="table">
										<thead>
											<tr>
												<th scope="col" className="product">
													Product
												</th>
												<th scope="col" className="product-name">
													Product Name
												</th>
												<th scope="col" className="customer-detail">
													Customer Details
												</th>
												<th scope="col" className="review-rating">
													Reviews & Rating
												</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td className="pro-img">
													<img src={detail_order_img} alt="" />
												</td>
												<td className="pro-name">Apricot Product</td>
												<td className="pro-details">
													Loremipsum <br />
													Loremipsum@gmail.com
												</td>
												<td className="pro-reviews">
													<div className="rev-wrapper">
														<div className="star-and-date">
															<ul>
																<li>
																	<img src={star} alt="" />
																</li>
																<li>
																	<img src={star} alt="" />
																</li>
																<li>
																	<img src={star} alt="" />
																</li>
																<li>
																	<img src={star} alt="" />
																</li>
																<li>
																	<img src={star} alt="" />
																</li>
															</ul>
															<span className="date">05 jan 2022</span>
														</div>
														<div className="rev-content">
															<p>
																Lorem Ipsum is simply dummy text of the printing
																and typesetting industry. Lorem Ipsum has been
																the industry's standard{" "}
															</p>
															<button
																type="button"
																className="btn btn-primary"
																data-bs-toggle="modal"
																data-bs-target="#staticBackdrop"
															>
																Send Feedback
															</button>
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<td className="pro-img">
													<img src={detail_order_img} alt="" />
												</td>
												<td className="pro-name">Appricot Product</td>
												<td className="pro-details">
													Loremipsum <br />
													Loremipsum@gmail.com
												</td>
												<td className="pro-reviews">
													<div className="rev-wrapper">
														<div className="star-and-date">
															<ul>
																<li>
																	<img src={star} alt="" />
																</li>
																<li>
																	<img src={star} alt="" />
																</li>
																<li>
																	<img src={star} alt="" />
																</li>
																<li>
																	<img src={star} alt="" />
																</li>
																<li>
																	<img src={star} alt="" />
																</li>
															</ul>
															<span className="date">05 jan 2022</span>
														</div>
														<div className="rev-content">
															<p>
																Lorem Ipsum is simply dummy text of the printing
																and typesetting industry. Lorem Ipsum has been
																the industry's standard{" "}
															</p>
															<button
																type="button"
																className="btn btn-primary"
																data-bs-toggle="modal"
																data-bs-target="#staticBackdrop"
															>
																Send Feedback
															</button>
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<td className="pro-img">
													<img src={detail_order_img} alt="" />
												</td>
												<td className="pro-name">Apricot Product</td>
												<td className="pro-details">
													Loremipsum <br />
													Loremipsum@gmail.com
												</td>
												<td className="pro-reviews">
													<div className="rev-wrapper">
														<div className="star-and-date">
															<ul>
																<li>
																	<img src={star} alt="" />
																</li>
																<li>
																	<img src={star} alt="" />
																</li>
																<li>
																	<img src={star} alt="" />
																</li>
																<li>
																	<img src={star} alt="" />
																</li>
																<li>
																	<img src={star} alt="" />
																</li>
															</ul>
															<span className="date">05 jan 2022</span>
														</div>
														<div className="rev-content">
															<p>
																Lorem Ipsum is simply dummy text of the printing
																and typesetting industry. Lorem Ipsum has been
																the industry's standard{" "}
															</p>
															<button
																type="button"
																className="btn btn-primary"
																data-bs-toggle="modal"
																data-bs-target="#staticBackdrop"
															>
																Send Feedback
															</button>
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<div className="paginations_results">
									<div className="showing_results">
										<p>
											Showing <b>7</b> of over 50 <b>results</b>
										</p>
									</div>
									<ul className="paginations">
										<li className="arrow prev-arrow">
											<i className="fa fa-angle-left" aria-hidden="true"></i>
										</li>
										<li className="pagi">1</li>
										<li className="pagi">2</li>
										<li className="pagi">3</li>
										<li className="pagi">..</li>
										<li className="pagi">90</li>
										<li className="arrow right-arrow">
											<i className="fa fa-angle-right" aria-hidden="true"></i>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Footer starts here */}
			<SellerFooter />
			{/* Footer ends here */}
		</>
	);
};

export default Seller_Reviews;
